import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableComponent } from './components/data-table/data-table.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ThemeToggleComponent } from './components/theme-toggle/theme-toggle.component';
import { ToastComponent } from './components/toast/toast.component';
import { RippleDirective } from './directives/ripple.directive';
import { ViewSwitcherComponent } from './components/view-switcher/view-switcher.component';
import { DataListComponent } from './components/data-list/data-list.component';
import { PrinterSettingsComponent } from './components/printer-settings/printer-settings.component';
import { PwaInstallPromptComponent } from './components/pwa-install-prompt/pwa-install-prompt.component';
import { PwaUpdatePromptComponent } from './components/pwa-update-prompt/pwa-update-prompt.component';
import { OfflineIndicatorComponent } from './components/offline-indicator/offline-indicator.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { CustomerFormComponent } from './components/customer-form/customer-form.component';
import { ProductFormComponent } from './components/product-form/product-form.component';
import { ActionIconComponent } from './components/action-icon/action-icon.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { BillPrintFormatModalComponent } from './components/bill-print-format-modal/bill-print-format-modal.component';

@NgModule({
  declarations: [
    DataTableComponent,
    PaginationComponent,
    ThemeToggleComponent,
    ToastComponent,
    RippleDirective,
    ViewSwitcherComponent,
    DataListComponent,
    PrinterSettingsComponent,
    PwaInstallPromptComponent,
    PwaUpdatePromptComponent,
    OfflineIndicatorComponent,
    SearchableSelectComponent,
    CustomerFormComponent,
    ProductFormComponent,
    ActionIconComponent,
    ConfirmDialogComponent,
    BillPrintFormatModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    DataTableComponent,
    DataListComponent,
    PaginationComponent,
    ViewSwitcherComponent,
    ThemeToggleComponent,
    ToastComponent,
    PrinterSettingsComponent,
    PwaInstallPromptComponent,
    PwaUpdatePromptComponent,
    OfflineIndicatorComponent,
    SearchableSelectComponent,
    CustomerFormComponent,
    ProductFormComponent,
    ActionIconComponent,
    ConfirmDialogComponent,
    BillPrintFormatModalComponent,
    RippleDirective,
    CommonModule
  ]
})
export class SharedModule { }

